import {I18n} from '@aws-amplify/core';
import {Badge} from '@mantine/core';

/**
 * FNP-918: the `paid` flag as a badge (§13).
 *
 * ⚠️ Same fix as StatusBadge: this hardcoded '#007bff' / '#6c757d', which §2
 * forbids — a hex value cannot follow the colour scheme, so a badge tuned for
 * light mode loses contrast in dark. Theme tokens resolve per scheme.
 *
 * Green/grey rather than the old blue/grey: paid is a SETTLED state and reads
 * as such next to the green `paid` StatusBadge, where blue would suggest
 * "in progress" — the meaning `open` already carries.
 *
 * Text, not colour alone (§13): the badge renders Paid / Unpaid rather than the
 * old lowercase "yes"/"no", which said nothing on its own once separated from
 * its column header.
 */
export const PaymentStatusBadge = ({status}: {status?: boolean}) => {
    const paid = status === true;

    return (
        <Badge
            color={paid ? 'green' : 'gray'}
            variant='light'
        >
            {paid ? I18n.get('Paid') : I18n.get('Unpaid')}
        </Badge>
    );
};
